import { useRouter } from "next/router";
import { getCookies } from "cookies-next";
import { useTranslation } from "next-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect, useRef, useState } from "react";
import { getProductsBySkus } from "@/services/product";
import { useBodyScrollLock } from "@/hooks/useBodyScrollLock";

import Image from "../global/Image";
import CheckIcon from "../icons/CheckIcon";
import ArrowIcon from "../icons/ArrowIcon";
import ProductCard from "../global/ProductCard";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import { useCart } from "@/context/cart";
import InstallmentWidgets from "../product/installments";
import { priceFormattedObject, validatePrice } from "@/helpers/product";
import { calcCartTotalHandler } from "@/helpers/cart";
import CurrencyIcon from "../icons/CurrencyIcon";

function CartInfo({ Context }) {
  const {
    t,
    i18n: { language },
  } = useTranslation("common");
  const { push } = useRouter();
  const { handshake } = getCookies();
  const cartItem = Context.state.cartPayload;
  const [, setPageLoading] = useState(true);
  const ref = useRef();
  useOnClickOutside([ref], () =>
    Context?.dispatch({ type: "cartInfo", payload: "" })
  );
  useEffect(() => {
    setPageLoading(false);
  }, []);
  const { cart } = useCart();
  console.log(cart);
  // related products if user did not add product to cart from PDP
  const [relatedProducts, setRelatedProducts] = useState(
    Context.state.relatedProducts
  );
  const [swiper, set_swiper] = useState({});

  async function getRelatedPoducts(skus) {
    return await getProductsBySkus(handshake, skus);
  }

  useEffect(() => {
    if (
      cartItem?.custom_related_products?.length &&
      Context.state.relatedProducts != undefined
    ) {
      getRelatedPoducts(cartItem?.custom_related_products).then(
        (res) =>
          res.status == 200 && setRelatedProducts(res?.data?.data?.products)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const truncateToTwoDecimals = (number) => parseFloat(number?.toFixed(2));

  useBodyScrollLock();

  const totals = calcCartTotalHandler(cart?.cartItems || []);
  console.log("cart?.cartItems -------- ", cart?.cartItems);
  // "https://aw-dev.b-cdn.net/media//catalog/product/1/0/1088774-7_1.jpg"
  return (
    <div
      className="absolute top-[35%] md:top-0 start-0 w-full mx-auto md:w-[500px] sm:min-h-screen min-h-[80vh] sm:max-h-screen max-h-[80vh] overflow-y-auto bg-white max-sm:rounded-t-xl"
      ref={ref}
    >
      <div className="flex items-center gap-2 px-4 pt-4 pb-2 bg-white max-sm:pb-0">
        <span className="grid text-white rounded-full size-4 sm:size-6 bg-secondary-800 place-items-center">
          <CheckIcon className="size-2 sm:size-3" />
        </span>
        <h4 className="text-sm font-bold sm:text-[20px]">
          {t("Added to cart successfully")}
        </h4>
      </div>
      <div className="p-4 pt-0 max-sm:p-2">
        <section className="sm:max-h-[80vh] sm:overflow-y-auto">
          {cart?.cartItems?.map((item, index) => {
            const price = validatePrice(priceFormattedObject(item));

            return (
              <div
                key={index}
                className="flex gap-3 p-2 my-3 border rounded-md max-sm:mt-0 "
              >
                <div className="p-3 border rounded-md">
                  <Image
                    loading="lazy"
                    // src={productImage}
                    src={
                      item?._media_?.image?.at(0)?.image ||
                      `${process.env.NEXT_PUBLIC_IMG_BASEURL}/catalog/product${item?.extension_attributes?.product_image}` ||
                      "https://aw2.v4tech.com/media/catalog/productundefined"
                    }
                    className="object-contain w-36 h-28 max-sm:size-24"
                    alt=""
                  />
                </div>
                <div className="flex flex-col w-full sm:gap-1">
                  <p className="font-bold line-clamp-2 max-sm:text-[13px]">
                    {item?.name}
                  </p>
                  <div className="flex items-center gap-1 max-sm:text-[13px]">
                    <span className="text-xl text-yellow-500">&#9733;</span>
                    <span>4.0</span>
                  </div>
                  {/* <PriceSection /> */}
                  <div className="flex items-center gap-4">
                    <p className="font-bold text-secondary-900 max-sm:text-[15px] flex items-center gap-1">
                      {truncateToTwoDecimals(
                        price?.specialPrice || price?.originalPrice
                      )}{" "}
                      <CurrencyIcon className="size-3.5" />
                    </p>
                    {price?.specialPrice && (
                      <p className="flex items-center gap-1 text-sm font-semibold line-through max-sm:text-xs text-zinc-400">
                        {truncateToTwoDecimals(price?.originalPrice)}{" "}
                        <CurrencyIcon className="size-3.5" />
                      </p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </section>
        {/* <Image
          src="/imgs/cart-modal-banner.png"
          className="hidden object-contain w-full h-auto md:block"
          alt="Tamara Sheet Img!"
        /> */}
        <InstallmentWidgets fromCartModal locale={language} amount={totals} />
        {relatedProducts?.length ? (
          <h3 className="my-2 sm:text-[20px] font-bold text-[#784891]">
            {language === "en" ? "Related Products" : "منتجات ذات صلة"}
          </h3>
        ) : null}
        {relatedProducts?.length > 0 ? (
          <div className="relative mb-10">
            {relatedProducts?.length > 2 && (
              <button
                onClick={() => swiper.slidePrev()}
                className="absolute z-50 grid p-1 -translate-y-1/2 bg-white border rounded-full -right-2 sm:p-2 top-1/2 sm:-right-4 size-7 sm:size-9 place-items-center"
              >
                <ArrowIcon className="max-sm:size-3" />
              </button>
            )}
            <Swiper
              onInit={(e) => set_swiper(e)}
              loop
              spaceBetween={10}
              breakpoints={{
                320: {
                  slidesPerView: 2.5,
                },
                450: {
                  slidesPerView: 2,
                },
              }}
            >
              {relatedProducts?.map((product, key) =>
                product?.stock?.is_in_stock ? (
                  <SwiperSlide key={key}>
                    <ProductCard {...{ t, product, fromSwiper: true }} />
                  </SwiperSlide>
                ) : null
              )}
            </Swiper>
            {relatedProducts?.length > 2 && (
              <button
                onClick={() => swiper.slideNext()}
                className="absolute z-50 grid p-1 -translate-y-1/2 bg-white border rounded-full sm:p-2 top-1/2 -left-2 sm:-left-4 size-7 sm:size-9 place-items-center"
              >
                <ArrowIcon className="rotate-180 max-sm:size-3" />
              </button>
            )}
          </div>
        ) : null}
        <div className="fixed bottom-0 max-sm:left-1/2 grid w-[430px] max-sm:w-[95%] max-sm:-translate-x-1/2 grid-cols-2 gap-2 bg-white z-[3000] py-2">
          <button
            onClick={() => {
              push("/cart");
              setTimeout(() => {
                Context?.dispatch({ type: "cartInfo", payload: "" });
              }, 1500);
            }}
            className="w-full max-sm:text-xs p-2 text-sm font-semibold text-white border rounded-md bg-[#784891] sm:text-base"
          >
            {language === "en" ? "Go to cart page" : "الذهاب لعربة التسوق"}
          </button>
          <button
            onClick={() => Context?.dispatch({ type: "cartInfo", payload: "" })}
            className="w-full max-sm:text-xs p-2 text-sm font-semibold border rounded-md border-[#784891] text-[#784891] sm:text-base"
          >
            {language === "en" ? "Continue Shopping" : "متابعة التسوق"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CartInfo;
